import { autoCapitalize } from '@/utils/autoCapitalize'
import { PatientListData } from './PatientListMapper.types'
import { phoneReplace } from '@/utils/formatPhone'

class PatientListMapper {
  toDomain(persistencePatientData: PatientListData) {
    return {
      patientId: persistencePatientData?.id,
      patientName: autoCapitalize(persistencePatientData?.nome),
      patientCpf: persistencePatientData?.cpf,
      patientEmail: persistencePatientData?.email,
      patientPhone: phoneReplace(persistencePatientData?.celular),
    }
  }
}

export default new PatientListMapper()
